import { IconWrapper } from '../runtime';
export default IconWrapper('strikethrough', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M12.5 5.07597C12.5 5.07597 11.8918 1.45526 7.5 1.76903C3.10824 2.08281 2.49999 5.55824 4.5 7.00513C5.72742 7.89309 7.49997 7.96961 7.49997 7.96961M3.20674 10.8633C3.20674 10.8633 4 14.2393 8 14.2393M1 7.96966H15",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 14.2393C12 14.2393 12.5 10.9998 12.5 9.99976",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});